export const KEYBOARD = {
    ENTER: 'Enter',
    ESCAPE: 'Escape',
    ESCAPE_KEY_CODE: 27,
    KEY_DOWN: 'keydown',
    KEY_UP: 'keyup',
    SPACE: 'Space',
    TAB: 'Tab',
    TAB_KEY_CODE: 9,
    CLICK: 'click'
};

export const MOUSE = {
    CLICK: 'click',
    MOUSE_OVER: 'mouseover',
    MOUSE_OUT: 'mouseout'
};

export const WINDOW = {
    SCROLL: 'scroll',
    RESIZE: 'resize'
};
